import { render } from "./CalendarItem.vue?vue&type=template&id=46d6e194&scoped=true"
import script from "./CalendarItem.vue?vue&type=script&lang=js"
export * from "./CalendarItem.vue?vue&type=script&lang=js"

import "./CalendarItem.vue?vue&type=style&index=0&id=46d6e194&lang=scss&scoped=true"

import exportComponent from "/home/forge/api-staging.champagne-booking.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-46d6e194"]])

export default __exports__